// Resolves the value of a `key` from the context passed in.
// {foo: {bar: 'baz'}}, 'foo.bar' => 'baz'
const resolveContext = (context, key, delim = '.') => {
  const keys = key.split(delim)
  return keys
    .slice(0, keys.length - 1)
    .reduce((acc, k) => acc[k] || {}, context)[keys[keys.length - 1]]
}

const KEY_PATTERN = /{{\s*([\w\.]+)\s*}}/g

export const render = (content, context) =>
  content.replace(KEY_PATTERN, (full, key) => {
    return resolveContext(context, key)
  })
